module.exports = __webpack_public_path__ + "img/logo.0a7e7a92.png";